import React from "react";
import useStyles from "isomorphic-style-loader/useStyles";
import classes from "./style.module.scss"
import withObserver from "../../../moduleable/modules/hoc/withObserver";
import deeplink from "../../../../../utils/deeplink";
import { FormattedMessage } from "react-intl";

import ProductImageSwiper from "./main-image-swiper";
import ProductPromotionContain, { ProductPromotionBgImage, UtmLimitDiscount } from "./promotion-contain";
import BasicInformation from "./basic-information";
import ProductColor from "./product-color";
import ProductSize from "./product-size";
import ProductActivityType from "./activity-type";
import { useSelector } from "react-redux";
import { isFlashSales } from "../../../../../utils/product";
import { Iconfont } from "../../../../components/icon/iconfont";
import { useMemo } from "react";
import { getSensorsUrl } from "../../../../utils/sensor";
import withSource from '../../../../../client/hocs/source-scoll';
import { PreOrderComponent } from "../../../listing/components/list/pre-order-compnents";

const SpecialFreeGifts = withSource(props => {
    const { freeGift, innerRef } = props;

    const handleClick = event => {
        event.preventDefault()
        const { currentTarget } = event;
        const href = currentTarget?.href
        window.location.href = getSensorsUrl(href, {
            resourcepage_title: currentTarget.getAttribute("data-title"),
            resource_type: currentTarget.getAttribute("data-type"),
            resource_position: currentTarget.getAttribute("data-position"),
            resource_content: currentTarget.getAttribute("data-content"),
        })
    }

    return <div className={classes.SpecialFreeGifts}>
        <a
            ref={innerRef}
            href="/cart/collect-products"
            data-title={'product'}
            data-position={'1'}
            data-type={'2'}
            data-content={'free gifts'}
            onClick={handleClick}
        >
            <Iconfont className={classes.Icon}>&#xe6da;</Iconfont>
            <span>{freeGift?.title} </span>
            <span>{freeGift?.description}</span>
        </a>
    </div>
})

const ProductMainContainer = props => {
    useStyles(classes);
    const {
        innerRef,
        reviewItem,
        productHooks,
        // shopTheLookData,
        onShow,
        showProm,
        setShowProm,
        showAddToCartModal,
        setShowAddToCartModal,
        setShowBtnEstimatedPrice
    } = props

    const {
        productVO,
        selectedProduct,
        quantity,
        setQuantity,
        isBeautyMakeup
    } = productHooks

    const pageProduct = useSelector(state => state.pageProduct);

    // const discountBulletinBoardEVent = () =>{
    //     let message = productVO?.discountBulletinBoard?.message?.replace(/<\/?.+?\/?>/g,"");
    //     if(window.GeekoSensors){
    //         window.GeekoSensors.Track("ELClick",{
    //             clicks: productVO?.discountBulletinBoard?.activityId || "",
    //             activity_type: message || "",
    //             page_sort: "product"
    //         })
    //     }
    // }

    const isFlash = isFlashSales(selectedProduct);

    const promotionsData = useMemo(() => {
        if (selectedProduct?.promotionalActivities?.length > 0) {
            let datas = selectedProduct.promotionalActivities;
            let freeGift;
            let promotions = [];
            datas.forEach((item) => {
                if (item?.activeType == "4" && item?.promotionType == "9") {
                    freeGift = item;
                } else {
                    promotions.push(item);
                }
            });

            return {
                freeGift: freeGift,
                promotions: promotions
            }
        } else {
            return null;
        }
    }, [selectedProduct.promotionalActivities]);

    const promotionImage = useMemo(() => {
        return selectedProduct?.promotionalSign?.bigBannerBackgroundImage
    }, [selectedProduct]);

    const showUtmPromotion = useMemo(() => {
        if (selectedProduct?.promotion) {
            const { promotion } = selectedProduct;
            return promotion?.type == "10" && promotion?.enabled && (promotion?.endTime - promotion?.serverTime) > 1000;
        }

        return false;
    }, [selectedProduct]);


    const isPreOrder = selectedProduct?.isPreOrder && selectedProduct?.promotion?.type === '11' && selectedProduct?.promotion?.enabled
	

    return <div id="mainNav" ref={innerRef}>
        <ProductImageSwiper
            product={selectedProduct}
            shopTheLookData={null}
            showPromotionImage={!showUtmPromotion && !!promotionImage}
            openShopTheLookMask={props?.openShopTheLookMask}
        />

        {
            showUtmPromotion ? <React.Fragment>
                <UtmLimitDiscount
                    promotion={selectedProduct.promotion}
                    offset={selectedProduct.promotion.endTime - selectedProduct.promotion.serverTime}
                />
            </React.Fragment> : <React.Fragment>
                {
                    promotionImage ? <React.Fragment>
                        <ProductPromotionBgImage
                            promotionImage={promotionImage}
                            promotionalSign={selectedProduct.promotionalSign}
                        />
                    </React.Fragment> : <React.Fragment>
                        {
                            promotionsData?.promotions?.length > 0 && <React.Fragment>
                                <ProductPromotionContain
                                    promotions={promotionsData.promotions}
                                    serverTime={productVO?.serverTime}
                                    productId={selectedProduct?.id}
                                />
                            </React.Fragment>
                        }
                    </React.Fragment>
                }
            </React.Fragment>
        }


        {/* {
            productVO?.discountMsg && <div className={classes.MpNotDiscount}>{productVO.discountMsg}</div>
        } */}

        {/* {
            productVO?.discountBulletinBoard?.message && <div className={classes.DiscountBulletinBoard}>
                <a href={deeplink(productVO?.discountBulletinBoard?.deepLink)} onClick={discountBulletinBoardEVent}>
                    <span className={classes.CouponIcon}></span>
                    <span dangerouslySetInnerHTML={{__html:productVO?.discountBulletinBoard?.message}}></span>
                </a>
            </div>
        } */}

        {
            promotionsData?.freeGift && <SpecialFreeGifts freeGift={promotionsData?.freeGift} />
        }

        <BasicInformation
            reviewItem={reviewItem}
            productHooks={productHooks}
            onShow={onShow}
            pageProduct={pageProduct}
            showProm={showProm}
            setShowProm={setShowProm}
            showAddToCartModal={showAddToCartModal}
            setShowAddToCartModal={setShowAddToCartModal}
            setShowBtnEstimatedPrice={setShowBtnEstimatedPrice}
        />
        {
            isPreOrder && <div className={`${classes.PreOrder}`}>
                <PreOrderComponent preorder={selectedProduct?.promotion} />
            </div>
        }



        <div className={`${classes.SizeColorContainer}`}>
            <ProductColor productHooks={productHooks} />

            <ProductSize productHooks={productHooks} />
        </div>

        {
            isBeautyMakeup && <div className={classes.ProductQuantityContainer}>
                <span style={{ marginRight: 5, backgroundColor: "#ffffff" }}><FormattedMessage id="qty" defaultMessage="Qty" />:</span>
                <span className={classes.QuantityChange} style={{ fontSize: 25 }} onClick={() => {
                    setQuantity(quantity > 2 ? (quantity - 1) : 1)
                }}>-</span>
                <input onChange={e => { setQuantity(e.target.value) }} type="number" value={quantity} pattern="[0-9]*" />
                <span className={classes.QuantityChange} onClick={() => {
                    setQuantity(quantity + 1)
                }}>+</span>
            </div>
        }

        {/* <ProductActivityType selectedProduct={selectedProduct} /> */}

        {
            isFlash && selectedProduct.promotion.maxPurchasePerTimeQty > 0 && <div className={classes.PurchaseLimit}>
                <FormattedMessage id="purchase_limit" defaultMessage="Purchase limit: {qty} qty" values={{ qty: selectedProduct.promotion.maxPurchasePerTimeQty }} />
            </div>
        }
    </div>
}

export default withObserver(ProductMainContainer);